//*
import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import {
	selectLogged,
} from './sessionSlice';
import styles from './Session.module.css';

// */

function IsSessionDefined(props: any) {
	if (props.session)
		return <div> yes there is a session defined</div>
	else
		return <div> no there is no session defined</div>
}

export function Profile() {
	const session = useAppSelector(selectLogged);
	const dispatch = useAppDispatch();
	const [userNameValue, setUserNameValue] = React.useState('');
	const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setUserNameValue(event.target.value);
	};

	const [passwordValue, setPasswordValue] = React.useState('');
	const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPasswordValue(event.target.value);
	};

	const testInputSx = {width: 350};

	/*
	if (state.user.session)
		const sess = <div>yes session</div>;
	else
		const sess = <div> no session</div>;

	   const sess = (state.user.session)
		   ? <div>yes session</div>
		   : <div> no session</div>;
	// */

	return (
		<div>
			<br /><br />
			<div className={styles.row}>
				Profile
			</div>
			<IsSessionDefined session={session} />
			<div className={styles.row}>
				<TextField
					required
					sx={testInputSx}
					id="outlined-required"
					label="Required"
					defaultValue=""
					onChange={handleUserNameChange}
				/>
			</div>
			<div className={styles.row}>
				<TextField
					id="outlined-password-input"
					sx={testInputSx}
					label="Password"
					type="password"
					autoComplete="current-password"
					onChange={handlePasswordChange}
				/>
			</div>
			<div className={styles.row}>
				<Button variant="outlined">Submit</Button>
			</div>
			<div className={styles.row}>
				<ul>
					<li>userName: { userNameValue }</li>
					<li>pswd: { passwordValue }</li>
					<li>token: { passwordValue }</li>
				</ul>
			</div>
		</div>
	);
}
